import { Alert } from 'app/models/dto/alert.model';

export class CreateNewDealAlert {
  static readonly type = '[DealAlerts] CreateNewDealAlert';
  constructor(public dealId: number, public alert: Alert) { }
}

export class GetDealErrors {
  static readonly type = '[DealAlerts] GetDealErrors';
  constructor(public borrowerId: number) { }
}

export class DismissDealError {
  static readonly type = '[DealAlerts] DismissDealError';
  constructor(public errorId: number, public dealId: number) { }
}

export class DismissDealAlert {
  static readonly type = '[DealAlerts] DismissDealAlert';
  constructor(public dealId: number, public alert: Alert) { }
}

export class ClearDealAlertsStore {
  static readonly type = '[DealAlerts] ClearDealAlertsStore';
  constructor() { }
}
